export const MINWAGE_SET_NOTIFICATIONS_ERROR = 'MINWAGE_SET_NOTIFICATIONS_ERROR'
export const MINWAGE_GET_WAGES_BY_JURISDICTION = 'MINWAGE_GET_WAGES_BY_JURISDICTION'
export const MINWAGE_SET_WAGES_BY_JURISDICTION = 'MINWAGE_SET_WAGES_BY_JURISDICTION'

export default {
  MINWAGE_SET_NOTIFICATIONS_ERROR,
  MINWAGE_GET_WAGES_BY_JURISDICTION,
  MINWAGE_SET_WAGES_BY_JURISDICTION
}
